function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.41 1.619a4.858 4.858 0 00-7.24 0L9.934 2.992 8.698 1.62C6.578-.54 3.4-.54 1.457 1.815c-1.943 2.159-1.943 5.69 0 7.849l1.236 1.374 7.24 8.24 7.241-8.044 1.237-1.374c2.119-2.354 2.119-6.083 0-8.241z",
  fill: "currentcolor",
  fillRule: "nonzero"
});

function SvgHeartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHeartActive;